import http from "../../utils/httpClient"

class purchaseOrderService {

    getPOProductList = async (query) => {
        return await http.get("/api/PurchaseOrder/GetPOProductList", { params: query })
    }

    createPO = async (data) => {
        return await http.post("/api/PurchaseOrder/CreatePO", data)
    }

    getPOList = async (query) => {
        return await http.get("/api/PurchaseOrder/GetPOList", { params: query })
    }

    getGeneralPOProductList = async (query) => {
        return await http.get("/api/PurchaseOrder/GetGeneralPOProductList", { params: query })
    }
    getPOProductsByPOId = async (query) => {
        return await http.get("/api/PurchaseOrder/GetPOProductsByPOId", { params: query })
    }

    getPONoByShopId = async (query) => {
        return await http.get("/api/PurchaseOrder/GetPONoByShopId", { params: query })
    }

    createReceivePO = async (data) => {
        return await http.post("/api/PurchaseOrder/ReceivePO", data)
    }

    GetPOStoreLocation = async (query) => {
        return await http.get("/api/PurchaseOrder/GetStoreLocation", { params: query })
    }

    getReceivePOList = async (query) => {
        return await http.get("/api/PurchaseOrder/GetReceivePOList", { params: query })
    }

    updateReceivePO = async (data) => {
        return await http.post("/api/PurchaseOrder/UpdateReceivePO", data)
    }

    createPaymentAdvice = async (data) => {
        return await http.post("/api/PurchaseOrder/CreatePaymentAdvise", data)
    }

    getSellerDataShopId = async (query) => {
        return await http.get("/api/PurchaseOrder/GetPONoByShopId", { params: query })
    }

    getPaymentAdviceProducts = async (query) => {
        return await http.get("/api/PurchaseOrder/GetRcvReturnPo", { params: query })
    }

    getVendorPaymentDetails = async (query) => {
        return await http.get("/api/PurchaseOrder/GetVendorPaymentDetails", { params: query })
    }

    getPaymentAdviseList = async (query) => {
        return await http.get("/api/PurchaseOrder/GetPaymentAdvise", { params: query })
    }

    getApprovalPaymentAdviseList = async (query) => {
        return await http.get("/api/PurchaseOrder/GetPendingPaymentAdvise", { params: query })
    }

    createReturnPO = async (data) => {
        return await http.post("/api/PurchaseOrder/CreateReturnPo", data)
    }
    
    getReturnPOList = async (query) => {
        return await http.get("/api/PurchaseOrder/GetReturnPo", { params: query })
    }
    
    getVendorAccountDetails = async (query) => {
        return await http.get("/api/PurchaseOrder/GetVendorAccountDetails", { params: query })
    }
    
    getPaymentAdviceExcelReport = async (query) => {
        return await http.get("/api/PurchaseOrder/GetExcelPaymentAdvise", { params: query })
    }
}

export default new purchaseOrderService()